<template>
  <div class="card modal-card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('remiseBancaire.detailReglementPiece.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'remiseBancaire.errors.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="columns mgt-20px">
        <div class="column is-2">
          <p class="has-text-default">{{$t('remiseBancaire.detailReglementPiece.typePiece') }}</p>
          <span class="has-text-weight-bold">
            {{ this.piece.pieceType }}
          </span>
        </div>
        <div class="column is-2">
          <p class="has-text-default">{{$t('remiseBancaire.detailReglementPiece.datePiece') }}</p>
          <span class="has-text-weight-bold">
            {{ this.piece.datePiece | formatDate }}
          </span>
        </div>
        <div class="column is-2">
          <p class="has-text-default">{{$t('remiseBancaire.detailReglementPiece.totalPiece') }}</p>
          <span class="has-text-weight-bold">
            {{ this.piece.montantPieceTtc | formatDevise }}
          </span>
        </div>
        <div class="column is-2">
          <p class="has-text-default"> {{$t('remiseBancaire.detailReglementPiece.affectation') }}
          </p>
          <span class="has-text-weight-bold">
            {{ getMontantAffecte() | formatDevise }}
          </span>
        </div>
        <div class="column is-2">
          <p class="has-text-default">{{$t('remiseBancaire.detailReglementPiece.resteAAffecter') }}
          </p>
          <span class="has-text-weight-bold">
            {{ this.resteALettrer | formatDevise }}
          </span>
        </div>
      </div>
      <b-table :data="piece.mouvementsClients" :bordered="true" :striped="true">
        <b-table-column field="facture"
                        v-slot="props"
                        :label="$t('remiseBancaire.detailReglementPiece.libelleEcheance')">
          <span v-if="props.row.modeReglement">{{ props.row.libelle }}</span>
        </b-table-column>
        <b-table-column field="modeReglement"
                        v-slot="props"
                        :label="$t('remiseBancaire.detailReglementPiece.modeReglement')">
          <span v-if="props.row.modeReglement">{{ props.row.modeReglement.libelle }}</span>
        </b-table-column>
        <b-table-column field="dateEcheance"
                        v-slot="props"
                        :label="$t('remiseBancaire.detailReglementPiece.dateEcheance')">
          <span>{{props.row.dateMouvement  | formatDate }}</span>
        </b-table-column>
        <b-table-column field="montant"
                        v-slot="props"
                        :label="$t('remiseBancaire.detailReglementPiece.montantEcheance')"
                        cell-class="right">
          <span>{{props.row.montantTtc | formatDevise}}</span>
        </b-table-column>
        <b-table-column field="montantRestant"
                        v-slot="props"
                        :label="$t('remiseBancaire.detailReglementPiece.resteEcheance')"
                        cell-class="right">
          <b-field position="is-right">
          <span>
            {{props.row.restantAAffecterInitial | formatDevise}}</span>
          </b-field>
        </b-table-column>
        <b-table-column v-slot="props" field="affecte">
          <div @click="assignAmount(props.row)">
              <b-icon icon="arrow-expand-right" type="is-primary"
                      class="is-cursor-pointer mgt-5px"></b-icon>
          </div>
        </b-table-column>
        <b-table-column field="inputAffecte"
                        v-slot="props"
                        :label="$t('remiseBancaire.detailReglementPiece.montantAffecte')">
          <input-currency v-model="props.row.inputAffectePopup"
                          :value="props.row.inputAffectePopup"
                          isNumber="true"
                          @input="calculateSolde(props.row)">
          </input-currency>
        </b-table-column>
        <b-table-column field="solde"
                        v-slot="props"
                        :label="$t('remiseBancaire.detailReglementPiece.soldeEcheance')"
                        cell-class="right">
          <span>{{ props.row.solde | formatDevise}}</span>
        </b-table-column>
      </b-table>

      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="terminer()">
              {{ $t('remiseBancaire.detailReglementPiece.terminer') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
    </div>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    piece: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    inputCurrency,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      resteALettrer: 0.0,
    };
  },
  methods: {
    getMontantAffecte() {
      if (this.piece.escompteApplicable === true) {
        return this.piece.montantEscompte + this.piece.inputAffecte;
      }
      return this.piece.inputAffecte;
    },
    calculateSolde(mouvementClient) {
      this.error = false;
      if (mouvementClient === null) return;
      if (mouvementClient.inputAffectePopup === null) {
        mouvementClient.inputAffectePopup = 0;
      }
      if (mouvementClient.inputAffectePopup >= mouvementClient.restantAAffecterInitial) {
        mouvementClient.inputAffectePopup = mouvementClient.restantAAffecterInitial;
        mouvementClient.solde = 0;
      } else {
        mouvementClient.solde = mouvementClient.restantAAffecterInitial
          - mouvementClient.inputAffectePopup;
      }
      let totalAffecteMouvementsClients = 0;
      this.piece.mouvementsClients.forEach(mc => {
        totalAffecteMouvementsClients += mc.inputAffectePopup;
      });
      this.resteALettrer = this.getMontantAffecte() - totalAffecteMouvementsClients;
    },
    assignAmount(row) {
      if (this.resteALettrer <= 0) return;
      if (row.inputAffectePopup === 0) {
        row.inputAffectePopup = Math.min(row.montantTtc, this.resteALettrer);
      } else {
        row.inputAffectePopup = Math.min(row.montantTtc,
          this.resteALettrer + row.inputAffectePopup);
      }
      this.calculateSolde(row);
    },
    terminer() {
      this.error = false;
      if (this.resteALettrer !== null && this.resteALettrer === 0.0) {
        if (this.piece !== null && this.piece.mouvementsClients !== null) {
          this.piece.resteALettrer = this.resteALettrer;
          this.piece.mouvementsClients.forEach(mc => {
            mc.inputAffecte = mc.inputAffectePopup;
            this.calculateSolde(mc);
          });
        }
        this.$parent.close();
        return;
      }
      this.error = true;
      this.messagesChampsVide = [];
      if (this.resteALettrer > 0) {
        this.messagesChampsVide.push(this.$t('remiseBancaire.msgError.errResteAAffecter',
          { resteALettrer: (this.resteALettrer).toFixed(2) }));
      } else {
        this.messagesChampsVide.push(this.$t('remiseBancaire.msgError.errTropAffecte',
          { resteALettrer: Math.abs((this.resteALettrer)).toFixed(2) }));
      }
    },
  },
  mounted() {
    if (this.piece === null || this.piece.mouvementsClients === null) return;
    this.resteALettrer = this.piece.resteALettrer;
    this.piece.mouvementsClients.forEach(mc => {
      mc.inputAffectePopup = mc.inputAffecte;
      this.calculateSolde(mc);
    });
  },
};

</script>
